import { BusinessDetails } from '../../slices/businessDetails';
import { CoverDetails } from '../../slices/coverDetails';
import { Quote } from '../../slices/quote';
import { Cover, DynamicCoverQuestionID } from '../../types/cover';
import { RiskClassCode } from '../../types/risk';
import { Nullable } from '../../types/utils';
import { dynamicQuestionExists, generateClauseFromDynamicCoverQuestion } from '../../utils';
import { RiskMetaType } from './getRiskMeta';

export const getTheftMoneyGlassRisk = ({
  riskMeta,
  businessDetails: { occupation },
  requestCovers,
  coverDetails,
  quote,
}: {
  riskMeta: RiskMetaType;
  businessDetails: Partial<BusinessDetails>;
  requestCovers: Cover[];
  coverDetails: Nullable<CoverDetails>;
  quote: Nullable<Quote>;
}) => ({
  ...riskMeta,
  ...{
    clauses: [
      ...generateClauseFromDynamicCoverQuestion(
        coverDetails.dynamicCoverQuestions ?? [],
        coverDetails.tobaccoSI,
        Cover.Theft,
        DynamicCoverQuestionID.TOBACCO_SI
      ),
    ],
  },
  riskClassCode: RiskClassCode.TheftMoneyGlass,
  riskDetail: {
    riskBPKTheftMoneyGlass: {
      occupationCode: occupation?.anzsicCode ?? '',
      occupationDescription: occupation?.occupation ?? '',
      business: occupation?.occupation ?? '',
      ...(requestCovers.includes(Cover.Theft) && {
        theft: {
          contentsSI: coverDetails.theftContentsSI!,
          theftExcess: quote.levelOfExcess!,
          ...(coverDetails.tobaccoSI &&
            dynamicQuestionExists(
              coverDetails.dynamicCoverQuestions ?? [],
              Cover.Theft,
              DynamicCoverQuestionID.TOBACCO_SI
            ) && {
              tobaccoSI: coverDetails.tobaccoSI,
            }),
          security: coverDetails.security!,
        },
      }),
      ...(requestCovers.includes(Cover.Money) && {
        money: {
          moneyExcess: quote.levelOfExcess!,
          blanketCover: 'Y',
          blanketCoverSI: coverDetails.moneySI!,
        },
      }),
      ...(requestCovers.includes(Cover.Glass) && {
        glass: {
          glassExcess: quote.levelOfExcess!,
        },
      }),
    },
  },
});
